import { ReactNode, FC } from 'react';
import { Select } from '@dynamika-shared/ui/Select/Select';
import { useFormContext } from 'react-hook-form';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { SubConditionTag } from './SubConditionTag';
import { conditionOperators } from './conditionOptions';
import { TaskDefinitionOption } from '@dynamika-shared/types/pmTaskDefinitions';

type TaskConditionsProps = {
  className?: string;
  children?: ReactNode;
};

export const TaskConditions: FC<TaskConditionsProps> = () => {
  const { setValue, watch } = useFormContext();
  const condition = watch('condition');

  const setRootType = (option: string) => {
    setValue('condition', { type: option });
  };

  const addConditionTag = () => {
    const newTag = { type: '.Tag', collectionElementType: { type: '.All' } };
    setValue('condition', {
      ...condition,
      conditions: condition?.conditions
        ? [...condition.conditions, newTag]
        : [newTag],
    });
  };

  return (
    <div>
      <h4 className='font-semibold text-[2.4rem] mb-3'>Conditions</h4>
      <div className='bg-blueTone p-3 ps-2 rounded-sm'>
        <div className={'grid grid-cols-[150px_1fr] gap-4'}>
          <div
            className={
              'text-1424 font-semibold field-required mt-2.5 max-w-[758px] w-[758px]'
            }
          >
            Condition
          </div>
          {condition.type !== '.Tag' ? (
            <Select
              required={true}
              listHeight={160}
              options={conditionOperators}
              value={condition.type}
              onChange={setRootType}
              placeholder={'Select Condition'}
              classNameLabel='pl-1.5'
              className={'max-w-[20.6rem]'}
              classNameInputWrapper={'flex'}
            />
          ) : (
            <div></div>
          )}
          <div></div>
          <div className={'flex flex-col gap-3'}>
            {condition.type === '.Tag' ? (
              <div
                className={
                  'w-full p-3 pt-1 pb-[20px] rounded-md border border-brightGray bg-[#F6F9FF]'
                }
              >
                <SubConditionTag path={'condition'} />
              </div>
            ) : (
              condition.conditions?.map(
                (_: TaskDefinitionOption, i: number) => (
                  <div
                    className={
                      'w-full p-3 pt-1 pl-0 pb-[20px] rounded-md border border-brightGray bg-[#F6F9FF]'
                    }
                    key={`condition.conditions[${i}]`}
                  >
                    <SubConditionTag
                      path={`condition.conditions[${i}]`}
                      index={i}
                    />
                  </div>
                )
              )
            )}
            <div>
              {condition?.type && condition?.type !== '.Tag' && (
                <Button
                  type={'text'}
                  className={'text-1424 text-vividTangelo font-medium'}
                  onClick={addConditionTag}
                >
                  + Add Subcondition
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
